import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _vm.pageLoad ? _c("div", {
    staticClass: "orderlist"
  }, [_c("a-card", [_c("a-form", {
    attrs: {
      layout: "inline"
    },
    nativeOn: {
      keyup: function keyup($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.query();
      }
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.orderKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.orderKeyword_placeholder")
    },
    model: {
      value: _vm.queryParam.condition.orderKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "orderKeyword", $$v);
      },
      expression: "queryParam.condition.orderKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.productKeyword")
    }
  }, [_c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.productKeyword_placeholder")
    },
    model: {
      value: _vm.queryParam.condition.productKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "productKeyword", $$v);
      },
      expression: "queryParam.condition.productKeyword"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    staticClass: "middleClass",
    staticStyle: {
      height: "42px"
    },
    attrs: {
      label: _vm.$t("orderList.OrderDate")
    }
  }, [_c("date-range", {
    ref: "orderDate",
    attrs: {
      allowClear: false,
      endDate: _vm.queryParam.condition.endOrderDate,
      startDate: _vm.queryParam.condition.startOrderDate
    },
    on: {
      change: _vm.changeOrderDate
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    staticStyle: {
      height: "42px"
    },
    attrs: {
      label: _vm.$t("orderList.orderStatus")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.orderStatus,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "orderStatus", $$v);
      },
      expression: "queryParam.condition.orderStatus"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus2")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus99")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus7")))])], 1)], 1)], 1), _vm.deliveryChannel == 1 ? _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.deliveryChannelId")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.deliveryChannelIds,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "deliveryChannelIds", $$v);
      },
      expression: "queryParam.condition.deliveryChannelIds"
    }
  }, _vm._l(_vm.deliveryChannelList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1) : _vm._e(), _c("a-col", {
    staticStyle: {
      height: "46px"
    },
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    staticClass: "middleClass",
    attrs: {
      label: _vm.$t("orderList.ArriveDate")
    }
  }, [_c("date-range", {
    ref: "ArriveDate",
    attrs: {
      endDate: _vm.queryParam.condition.startArriveDate,
      startDate: _vm.queryParam.condition.endArriveDate
    },
    on: {
      change: _vm.changeArriveDate
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.payId")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.payId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "payId", $$v);
      },
      expression: "queryParam.condition.payId"
    }
  }, _vm._l(_vm.payMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.customerKeyword")
    }
  }, [_c("a-tooltip", {
    attrs: {
      placement: "topLeft"
    }
  }, [_c("template", {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.customerKeyword_placeholder")) + " ")]), _c("a-input", {
    attrs: {
      maxLength: 100,
      allowClear: "",
      placeholder: _vm.$t("orderList.customerKeyword_placeholder")
    },
    model: {
      value: _vm.queryParam.condition.customerKeyword,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "customerKeyword", $$v);
      },
      expression: "queryParam.condition.customerKeyword"
    }
  })], 2)], 1)], 1), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.advanced,
      expression: "advanced"
    }]
  }, [_c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.deliveryMethod")
    }
  }, [_c("a-select", {
    attrs: {
      mode: "multiple",
      maxTagCount: 1,
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.queryParam.condition.deliveryWays,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "deliveryWays", $$v);
      },
      expression: "queryParam.condition.deliveryWays"
    }
  }, _vm._l(_vm.deliveryMethodList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1), _c("a-col", {
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("orderList.ddz")
    }
  }, [_c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect"),
      mode: "multiple"
    },
    model: {
      value: _vm.queryParam.condition.sellerCode,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam.condition, "sellerCode", $$v);
      },
      expression: "queryParam.condition.sellerCode"
    }
  }, _vm._l(_vm.ddzList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1)], 1)], 1)], 1), _c("a-col", {
    staticStyle: {
      "text-align": "right",
      float: "right",
      "line-height": "40px"
    },
    attrs: {
      md: 6,
      sm: 24
    }
  }, [_c("span", {
    staticClass: "table-page-search-submitButtons"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.query();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("publicuse.inquire2")) + " ")]), _c("a", {
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      click: function click($event) {
        _vm.advanced = !_vm.advanced;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.advanced ? this.$t("publicuse.putaway") : this.$t("publicuse.unfold")) + " "), _c("a-icon", {
    attrs: {
      type: _vm.advanced ? "up" : "down"
    }
  })], 1)], 1)])], 1)], 1)], 1), _c("a-card", {
    staticClass: "listBtn",
    staticStyle: {
      "min-width": "1460px"
    }
  }, [_c("a-row", {
    attrs: {
      type: "flex",
      justify: "end"
    }
  }, [_c("a-col", [_c("a-button", {
    staticStyle: {
      "margin-right": "8px"
    },
    attrs: {
      loading: _vm.syncLoading
    },
    on: {
      click: _vm.syncOrder
    }
  }, [_vm._v(_vm._s(_vm.$t("orderList.syncErpOrders")))])], 1)], 1), _c("a-table", {
    attrs: {
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: function showTotal(total, range) {
          return "".concat(_vm.$t("public.total"), "\uFF1A") + total;
        },
        current: _vm.queryParam.page,
        pageSize: _vm.queryParam.size,
        total: _vm.total
      },
      id: "sorttableclass",
      rowKey: "orderNo",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.orderList
    },
    on: {
      change: _vm.tableChange
    },
    scopedSlots: _vm._u([{
      key: "orderNo",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              name: "orderDetail",
              query: {
                id: record.id
              }
            }
          }
        }, [_vm._v(_vm._s(record.orderNo))])], 1)]);
      }
    }, {
      key: "customer",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("router-link", {
          staticClass: "underline",
          attrs: {
            target: "_blank",
            to: {
              path: "/customermanager/editcustomer2",
              query: {
                erpCustomerId: record.erpCustomerId,
                customerId: record.customerId
              }
            }
          }
        }, [_vm._v(" " + _vm._s(record.erpCustomerName == "" ? "          " : record.erpCustomerName) + " "), _c("div", [_vm._v(_vm._s(record.userAccount))])])], 1);
      }
    }, {
      key: "orderStatus",
      fn: function fn(text, record) {
        return _c("span", {}, [record.orderStatus ? _c("div", {
          staticClass: "orderStatus"
        }, [_vm._v(_vm._s(record.orderStatus == 1 ? _vm.$t("public.orderStatus2") : record.orderStatus == 2 ? _vm.$t("public.orderStatus99") : _vm.$t("public.orderStatus7")))]) : _vm._e(), _vm._v(" " + _vm._s(record.orderDate) + " ")]);
      }
    }, {
      key: "ColLang",
      fn: function fn(text, record) {
        return _c("span", {}, [_vm.deliveryChannel == 1 ? _c("div", [_vm._v(_vm._s(record.deliveryChannelTitle))]) : _vm._e()]);
      }
    }, {
      key: "arriveDate",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("div", [_vm._v(_vm._s(record.arriveDate))])]);
      }
    }, {
      key: "customerNote",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.customerNote) + " ")]), _vm._v(" " + _vm._s(record.customerNote) + " ")], 2)], 1);
      }
    }, {
      key: "orderTransportInfo",
      fn: function fn(text, record) {
        return _c("span", {}, _vm._l(_vm.jsonParse(record.orderTransportInfo), function (item, key, index) {
          return _c("dd", {
            key: key,
            staticClass: "colOrderTransportInfo"
          }, [_c("dl", [_vm._v(_vm._s(item.company))]), _c("dl", {
            staticStyle: {
              flex: "2"
            }
          }, [_vm._v(_vm._s(key))]), _c("dl", [_vm._v(_vm._s(_vm.$t("public.expressStatus".concat(item.status))))])]);
        }), 0);
      }
    }, {
      key: "orderServiceNote",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.orderServiceNote) + " ")]), _vm._v(" " + _vm._s(record.orderServiceNote) + " ")], 2)], 1);
      }
    }, {
      key: "orderSource",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "topLeft"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.userAgent) + " ")]), _vm._v(" " + _vm._s(record.userAgent) + " ")], 2)], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {
          staticStyle: {
            "white-space": "nowrap"
          }
        }, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.goDetail(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("orderList.details")))]), record.orderStatus == 1 ? _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }) : _vm._e(), record.orderStatus == 1 ? _c("a-popconfirm", {
          attrs: {
            placement: "topRight",
            title: _vm.$t("orderList.cacelTip"),
            "ok-text": _vm.$t("publicuse.determine"),
            "cancel-text": _vm.$t("publicuse.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.orderCancel(record);
            }
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("orderList.actionCancel")))])]) : _vm._e()], 1);
      }
    }], null, false, 2569624073)
  }, [_c("span", {
    attrs: {
      slot: "orderNoTitle"
    },
    slot: "orderNoTitle"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("orderList.colOrderNo")))])]), _c("span", {
    attrs: {
      slot: "orderStatusTitle"
    },
    slot: "orderStatusTitle"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("orderList.colOrderStatus")))]), _vm._v(" " + _vm._s(_vm.$t("orderList.colOrderDate")) + " ")]), _c("span", {
    attrs: {
      slot: "ColLangTitle"
    },
    slot: "ColLangTitle"
  }, [_vm.deliveryChannel == 1 ? _c("div", [_vm._v(_vm._s(_vm.$t("orderList.ColChannelTitle")) + " ")]) : _vm._e()]), _c("span", {
    attrs: {
      slot: "arriveDateTitle"
    },
    slot: "arriveDateTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.ColArriveDate")) + " ")]), _c("span", {
    attrs: {
      slot: "orderSourceTitle"
    },
    slot: "orderSourceTitle"
  }, [_vm._v(" " + _vm._s(_vm.$t("orderList.userAgent")) + " ")])])], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.editOrderTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderStatustHandle
    },
    model: {
      value: _vm.orderStatustVisible,
      callback: function callback($$v) {
        _vm.orderStatustVisible = $$v;
      },
      expression: "orderStatustVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderStatusRuleForm",
    attrs: {
      rules: _vm.orderStatusRules,
      model: _vm.orderStatusModalValue
    }
  }, [_c("a-alert", {
    attrs: {
      description: _vm.$t("orderList.tipsContent"),
      type: "warning",
      "show-icon": ""
    }
  }), _c("a-form-model-item", {
    attrs: {
      prop: "status"
    }
  }, [_c("a-tooltip", {
    attrs: {
      slot: "label",
      placement: "topRight"
    },
    slot: "label"
  }, [_c("span", {
    attrs: {
      slot: "title"
    },
    domProps: {
      innerHTML: _vm._s(_vm.$t("orderList.statusTipsContent"))
    },
    slot: "title"
  }), _vm._v(" " + _vm._s(_vm.$t("orderList.orderStatus")) + " "), _c("a-icon", {
    attrs: {
      type: "info-circle"
    }
  })], 1), _c("a-select", {
    attrs: {
      allowClear: "",
      placeholder: _vm.$t("publicuse.pleaseselect")
    },
    model: {
      value: _vm.orderStatusModalValue.status,
      callback: function callback($$v) {
        _vm.$set(_vm.orderStatusModalValue, "status", $$v);
      },
      expression: "orderStatusModalValue.status"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus1")))]), _c("a-select-option", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus2")))]), _c("a-select-option", {
    attrs: {
      value: "3"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus3")))]), _c("a-select-option", {
    attrs: {
      value: "4"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus4")))]), _c("a-select-option", {
    attrs: {
      value: "5"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus5")))]), _c("a-select-option", {
    attrs: {
      value: "6"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus6")))]), _c("a-select-option", {
    attrs: {
      value: "8"
    }
  }, [_vm._v(_vm._s(_vm.$t("public.orderStatus8")))])], 1)], 1)], 1)], 1), _vm.orderSendDateVisible ? _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.editSendDateTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderSendDateHandle
    },
    model: {
      value: _vm.orderSendDateVisible,
      callback: function callback($$v) {
        _vm.orderSendDateVisible = $$v;
      },
      expression: "orderSendDateVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderSendDateRuleForm",
    attrs: {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 14
      },
      rules: _vm.orderSendDateRules,
      model: _vm.orderSendDateModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderList.btnPlanSendTime"),
      prop: "date"
    }
  }, [_c("a-date-picker", {
    attrs: {
      valueFormat: "YYYY-MM-DD"
    },
    model: {
      value: _vm.orderSendDateModalValue.date,
      callback: function callback($$v) {
        _vm.$set(_vm.orderSendDateModalValue, "date", $$v);
      },
      expression: "orderSendDateModalValue.date"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.orderNoteVisible ? _c("a-modal", {
    attrs: {
      title: _vm.$t("orderList.addOrderNoteTitle"),
      destroyOnClose: "",
      maskClosable: false
    },
    on: {
      ok: _vm.orderNoteHandle
    },
    model: {
      value: _vm.orderNoteVisible,
      callback: function callback($$v) {
        _vm.orderNoteVisible = $$v;
      },
      expression: "orderNoteVisible"
    }
  }, [_c("a-form-model", {
    ref: "orderNoteRuleForm",
    attrs: {
      rules: _vm.orderNoteRules,
      model: _vm.orderNoteModalValue
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("orderList.orderNote"),
      prop: "note"
    }
  }, [_c("a-textarea", {
    attrs: {
      "auto-size": {
        minRows: 3,
        maxRows: 5
      }
    },
    model: {
      value: _vm.orderNoteModalValue.note,
      callback: function callback($$v) {
        _vm.$set(_vm.orderNoteModalValue, "note", $$v);
      },
      expression: "orderNoteModalValue.note"
    }
  })], 1)], 1)], 1) : _vm._e(), _c("a-modal", {
    attrs: {
      title: _vm.$t("public.tip"),
      visible: _vm.mergeVisible,
      footer: null
    },
    on: {
      cancel: function cancel() {
        return _vm.mergeVisible = false;
      }
    }
  }, [_c("span", [_vm._v(_vm._s(_vm.$t("orderList.mergeContent", {
    orderNo: _vm.mergeOrderNo
  })))]), _c("router-link", {
    attrs: {
      target: "_blank",
      to: "/orderDetail?id=" + _vm.mergeOrderid
    }
  }, [_vm._v(_vm._s(_vm.$t("public.lookData")))])], 1)], 1) : _vm._e();
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };